<div class="container">
  @for (recipeTemplate of recipeTemplates | sortTemplates; track recipeTemplate) {
    <recipe-template [recipeTemplate]="recipeTemplate" [integrationType]="integrationType"></recipe-template>
  }
</div>
